import lottie from 'lottie-web';
import introLeftAnimData from './lottie/intro-left.json';
import introRightAnimData from './lottie/intro-right.json';
import detectIe from 'detectie';



let anim1, anim2;

const init = root => {
    anim1 = lottie.loadAnimation({
        container: root.querySelector('#intro-left'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: introLeftAnimData
    });

    anim2 = lottie.loadAnimation({
        container: root.querySelector('#intro-right'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: introRightAnimData
    });


    if (detectIe()) {
        const viewBox1 = anim1.renderer.svgElement.getAttribute('viewBox').split(' ');
        const viewBox2 = anim2.renderer.svgElement.getAttribute('viewBox').split(' ');

        anim1.renderer.svgElement.style.width = window.innerHeight * (viewBox1[2] / viewBox1[3]) + 'px';
        anim1.renderer.svgElement.style.height = window.innerHeight + 'px';
        anim2.renderer.svgElement.style.width = window.innerHeight * (viewBox2[2] / viewBox2[3]) + 'px';
        anim2.renderer.svgElement.style.height = window.innerHeight + 'px';
    } else {
        anim1.renderer.svgElement.style.width = '';
        anim1.renderer.svgElement.style.height = '';
        anim2.renderer.svgElement.style.width = '';
        anim2.renderer.svgElement.style.height = '';
    }

    setTimeout(() => {
        anim1.setSpeed(0.7);
        anim2.setSpeed(0.7);
        anim1.play();
        anim2.play();
    }, 200);
};

const destroy = () => {
    anim1.destroy();
    anim2.destroy();
    anim1 = anim2 = null;
};

export default {
    init,
    destroy
};


// WEBPACK FOOTER //
// ./js/intro.js